<app-nav titulo="Contratos de Locación" descripcion="Aquí podrá ver, editar y gestionar los contratos de locación.">
  <div class="contracts">
    <!-- Filtros -->
    <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
    <!-- Tabla de contratos -->
    <app-data-table [rows]="contracts" [columns]="columns" [paginatorStatus]="paginatorStatus"
      [externalPagination]="true" (updateRows)="updateContracts($event)" (sortFn)="updateSort($event)"></app-data-table>
    <button mat-raised-button class="garantor-button add-button" color="primary" routerLink="./nueva"
      *ngIf="userType === 'AGENTE' || userType === 'CORPORATIVO'">
      <mat-icon matPrefix class="add-button-icon">add</mat-icon>
      <span class="add-button-label">Nuevo Contrato</span>
    </button>
  </div>
</app-nav>

<!-- Columna de botones -->
<ng-template #buttonsColumnTemplate let-row="row">
  <div class="table-row-buttons">
    <button mat-icon-button matTooltip="Ver detalles" class="view-more-row-button" [routerLink]="'./' + row.contratoId">
      <mat-icon color="primary">dehaze</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Eliminar contrato" class="delete-row-button" (click)="deleteContract(row)">
      <mat-icon color="accent">delete</mat-icon>
    </button>
  </div>
</ng-template>